import React from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { pagesRoute, posRoutes, publicRoutes } from "./router.link";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { all_routes } from "./all_routes";
// import ThemeSettings from "../InitialPage/themeSettings";

const AllRoutes = () => {
  // const GlobalState = useSelector((state) => state.access_control);

  const data = useSelector((state) => state.toggle_header);
  const access_control = useSelector((state) => state.access_control);

  console.log(access_control, "access_control");

  const HeaderLayout = () => (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
      {/* <Loader /> */}
      <Header />
      <Sidebar />
      <Outlet />
      {/* <ThemeSettings /> */}
    </div>
  );

  const Authpages = () => (
    <div className={data ? "header-collapse" : ""}>
      <Outlet />
      {/* <Loader /> */}
      {/* <ThemeSettings /> */}
    </div>
  );

  const Pospages = () => (
    <div>
      <Header />
      <Outlet />
      {/* <Loader /> */}
      {/* <ThemeSettings /> */}
    </div>
  );

  return (
    <div>
      <Routes>
        <Route path="/pos" element={<Pospages />}>
          {posRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
        {/* {GlobalState?.AuthToken ? ( */}
        {access_control?.AuthToken ? (
          <Route path={"/"} element={<HeaderLayout />}>
            {publicRoutes.map((route, id) => (
              <Route path={route.path} element={route.element} key={id} />
            ))}
          </Route>
        ) : (
          // Redirect to Sign In if not authenticated
          <Route path="*" element={<Navigate to={all_routes.signin} />} />
        )}
        {/* ) : (
          <>
            <Route path="/" element={<Navigate to="/signin" />} />
            <Route path="*" element={<Navigate to="/signin" />} />
          </>
        )} */}

        <Route path={"/"} element={<Authpages />}>
          <Route
            path="/"
            element={
              <Navigate
                to={
                  access_control?.AuthToken
                    ? all_routes.jobapplication
                    : all_routes.signin
                }
              />
            }
          />
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
    </div>
  );
};
export default AllRoutes;
